
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/BlogBoardPage/BlogBoardPage",
      function () {
        return require("private-next-pages/blogs/BlogBoardPage/BlogBoardPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/BlogBoardPage/BlogBoardPage"])
      });
    }
  